// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__3hBjg","no-bg":"Layout_no-bg__5k8N+"};